// extracted by mini-css-extract-plugin
export default {"hotWrapper":"HotNews_hotWrapper__PXn68","hotWrapper_link":"HotNews_hotWrapper_link__RWtGl","hotWrapper_text":"HotNews_hotWrapper_text__UuS8A"};